module.exports = function getResource(label, vars = []) {
    const resources = {
        chooseDeliveryFreq: 'Choisir la fréquence de livraison :',
        every: 'Chaque',
        mostCommon: 'Le plus courant',
        youWillSave: 'vous économiserez',
        annualyWithSubs: 'chaque année avec cet abonnement.',
        save: 'Enregistrer',
        cancel: 'Annuler',
        frequencyNumber: 'Nombre de fréquence',
        frequencyType: 'Type de fréquence',
        item: 'ARTICLE',
        actualPrice: 'Prix réel',
        originalPrice: 'Prix initial'
    };

    return resources[label];
};
